module.exports = __webpack_public_path__ + "static/media/lift-elevator-icon (1).1e0276c6.svg";